export const TOTAL_PAID_HOURS = 'totalPaidHours';
export const TOTAL_PIECE_RATE_HOURS = 'totalPieceRateHours';
